import { Component, inject, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-ritwiki-withdraw-funds',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './ritwiki-withdraw-funds.component.html',
  styleUrl: './ritwiki-withdraw-funds.component.scss'
})
export class RitwikiWithdrawFundsComponent {
  withDrawAmount: number = 0;
  withDrawAmountDisplay: string = '';
  exceedsAmount: boolean = false;
  optionalMsg: string = '';
  data: any = '';
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public sheetData: any,
    @Optional() private dialogRef?: MatDialogRef<RitwikiWithdrawFundsComponent>,
    @Optional() private sheetRef?: MatBottomSheetRef<RitwikiWithdrawFundsComponent>
  ) {
    this.data = dialogData || sheetData;
  }

  onInputOfAmount(value: string) {
    const raw = value.replace(/,/g, '').replace(/₹/g, '').replace(/[^\d]/g, '');
    const rawNum = Number(raw);
    if (rawNum > this.data.amount) {
      this.exceedsAmount = true;
      return;
    }
    this.exceedsAmount = false;
    this.withDrawAmount = rawNum || 0;
    this.withDrawAmountDisplay = this.withDrawAmount ? `₹${this.withDrawAmount.toLocaleString('en-IN')}` : '';
  }

  preventLetters(value: KeyboardEvent) {
    const pattern = /^[0-9]$/;
    let input = value.key
    if (!pattern.test(input) && value.key !== 'Backspace' && value.key !== 'Enter' && value.key !== 'Tab') {
      value.preventDefault();
    }
  }

  onSubmit() {
    const transaction = { amount: this.withDrawAmount, description: this.optionalMsg }
    if (this.dialogRef) {
      this.dialogRef.close(transaction);
    } else if (this.sheetRef) {
      this.sheetRef.dismiss(transaction);
    }
  }

  onClose() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else if (this.sheetRef) {
      this.sheetRef.dismiss();
    }

  }
}
